export default __webpack_public_path__ + "static/media/inwardIcon.b7281cf2.svg";